import Vue from "vue";
import api from "@/api.js";
import axios from "axios";
import Formatters from "@/assets/js/formatters"
import Editors from "@/assets/js/editors"
import filterType from "@/assets/js/filterType";
import router from "@/router"


const grid = {
  namespaced: true,
  state: {
    grid: {},
    viewMode: true,
    toggleGridResize: false
  },

  getters: {
    getGrid: state => state.grid,
    getViewMode: state => state.viewMode,
    getToggleGridResize: state => state.toggleGridResize,
    getRefundByGridId: state => id => {
      if (!state.grid[id]) return null;
      return state.grid[id].refundList;
    },
    getIfColumnInit: state => gridId => {
      let gridIdArr = gridId.split(",");

      let isInit = false;
      gridIdArr.forEach(gridId => {
        //check if grid exists
        if (!state.grid[gridId]) {
          isInit = false;
          return;
        }
        //check if grid columns exists
        if (!state.grid[gridId].columns) {
          isInit = false;
          return;
        } else {
          if (state.grid[gridId].columns.length == 0) {
            // console.error("asdasd")
            isInit = false;
            return;
          }
        }
        //default
        isInit = true;
      });
      return isInit;
    },
    getGridById: state => id => {
      if (!state.grid[id]) return {};
      return state.grid[id];
    }
  },

  actions: {
    actionSetToggleGridResize({ commit }, toggleGridResize) {
      commit("setToggleGridResize", toggleGridResize);
    },


    actionSetViewMode({ commit }, viewMode) {
      commit("setViewMode", viewMode);
    },
    actionResetAllGrid({ commit }) {
      commit("resetAllGrid");
    },
    actionResetGrid({ commit }, id) {
      commit("resetGrid", id);
    },
    actionSetGrid({ commit }, obj) {
      commit("reloadData", obj.gridId);
      commit("setGrid", obj);
    },
    actionSetGridWithoutReload({ commit }, obj) {
      // commit("reloadData", obj.gridId);
      commit("setGrid", obj);
    },
    actionSetSelectRowsIndex(
      { commit, state },
      { gridId, selectRowsIndex, isModeManager }
    ) {
      let totalAmount = 0;

      let data = Object.assign({}, state.grid[gridId].data);
      let selectRows = [];

      if (!isModeManager) {
        selectRowsIndex.forEach(index => {
          let rows = data[index];
          totalAmount += rows.SUM_AMOUNT ? rows.SUM_AMOUNT : 0;
          selectRows.push(rows);
        });
        // totalAmount = Number.parseFloat(totalAmount).toFixed(2);


        commit("setTotalAmount", { gridId, totalAmount });
      }
      commit("setSelectRowsIndex", { gridId, selectRows });
    },

    actionSetAction(
      { commit, state },
      { gridId, mode, selectRows }
    ) {

      commit("setMode", { gridId, mode });
      commit("setSelectRows", { gridId, selectRows });
    },

    actionSetSelectRows(
      { commit, state },
      { gridId, selectRows }
    ) {

      commit("setSelectRows", { gridId, selectRows });
    },

    actionSetTotalAmount({ commit }, { gridId, totalAmount }) {
      commit("setTotalAmount", { gridId, totalAmount });
    },
    actionSetColumnName({ commit }, { gridId, colObj }) {
      commit("setColumnName", { gridId, colObj });
    },
    actionSetLoading({ commit }, { gridId, loading }) {
      commit("setLoading", { gridId, loading });
    },
    actionSetSelectRequestFilter({ commit, state }, { gridId, requestFilter }) {
      if (!state.grid[gridId]) {
        commit("setGrid", {
          gridId: gridId,
          requestFilter: requestFilter
        });
      } else {
        commit("setSelectRequestFilter", { gridId, requestFilter });
      }

      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          resolve();
        }, 100);
      });
    },

    actionTogglePage({ commit }, obj) {
      commit("togglePage", obj);
    },

    actionExportExcel(
      { commit, dispatch, state },
      { access_code, page, isBlob }
    ) {
      // console.log(grid.sessionId);
      let allGrid = Object.assign({}, state.grid);

      let requestArr = [];
      Object.entries(allGrid).forEach(([key, grid]) => {
        let obj = {
          requestId: grid.requestId,
          title: grid.title,
          columns: grid.columns.map(item => ({ field: item.field, name: item.name, formatterString: item.formatterString }))
        };
        if (grid.isMainGrid) {
          //if main grid , push first
          requestArr = [obj, ...requestArr];
        } else {
          requestArr.push(obj);
        }
      });

      api.request(
        page,
        "post",
        "/" + access_code + "/Export",
        {
          SessionID: JSON.parse(window.localStorage.getItem("ccrs_user"))
            .session_id,
          //LocaleCode: this.$store.state.user.locale_code,

          Parameters: {
            filters: grid.filterItem,
            requestArr: requestArr,
          }
        },
        function (r) { },
        function (r) { },
        false,
        isBlob ? "blob" : null
      );
    },
    actionSetFilterItem({ commit }, { gridId, filterItem }) {
      commit("setFilterItem", { gridId, filterItem })
    },
    actionRequest({ commit, state, dispatch }, obj) {

      return new Promise((resolve, reject) => {

        let tempObj = {};

        let newObj = {};
        //if the grid is exist
        if (state.grid[obj.gridId]) {
          Object.assign(tempObj, state.grid[obj.gridId]);
        }
        newObj = Object.assign(tempObj, obj);
        let page = newObj.page;
        let uri = newObj.uri;


        if (newObj.filterItem) {
          newObj.filterItem["bdw_page_num"] = newObj.pageNum;
          newObj.filterItem["bdw_page_size"] = newObj.pageSize;


        }

        
        // console.time("api run time ");



        api.request(
          page,
          "post",
          uri,
          {
            //get grid session id first
            SessionID: newObj.token,
            //LocaleCode: this.$store.state.user.locale_code,
            Parameters: {
              filters: newObj.filterItem,
              isworkID: page.$route.params.id,
              maintainParam: newObj.maintainParam,
              columns: newObj.columns,
              requestId: newObj.requestId,
              sum_amount_column: newObj.sum_amount_column,
              temp_date_column: newObj.temp_date_column
            }
          },
          function (r) {
            if (typeof newObj.success === "function") {
              newObj.success.call(newObj.page, r);
            }
            //this.getDataSuccess(r);
            Object.entries(r.data).forEach(([key, value]) => {
              if (value !== undefined && value !== null) {
                if (key == "tableData") {
                  newObj["data"] = value;
                } else {
                  newObj[key] = value;
                }
              }
            });
            commit("setGrid", newObj);
            commit("setViewMode", true);
            resolve(r);
          },
          function (r) {
            if (typeof newObj.fail === "function") {
              newObj.fail.call(newObj.page, r);
            }
            commit("setViewMode", true);
            reject(r);
          },
          false,
          newObj.isBlob ? "blob" : null
        );
      });
    },

    actionRequestAll({ commit, state, dispatch }, objArr) {
      return new Promise((resolve, reject) => {
        let promiseArr = [];
        let newGridObjArr = [];
        dispatch("actionSetBlock", true, {
          root: true
        });

        objArr.forEach(obj => {
          let tempObj = {};
          let newObj = {};
          //if the grid is exist
          if (state.grid[obj.gridId]) {
            Object.assign(tempObj, state.grid[obj.gridId]);
          }
          newObj = Object.assign(tempObj, obj);



          if (newObj.filterItem) {
            newObj.filterItem["bdw_page_num"] = newObj.pageNum;
            newObj.filterItem["bdw_page_size"] = newObj.pageSize;
          }

          let page = newObj.page;
          let uri = newObj.uri;
          promiseArr.push(
            api.requestMultiple(page, "post", uri, {
              SessionID: JSON.parse(window.localStorage.getItem("ccrs_user"))
                .session_id,
              //LocaleCode: this.$store.state.user.locale_code,
              Parameters: {
                isworkID: page.$route.params.id,
                filters: newObj.filterItem,
                maintainParam: newObj.maintainParam,
                columns: newObj.columns,
                requestId: newObj.requestId,
                sum_amount_column: newObj.sum_amount_column,
                temp_date_column: newObj.temp_date_column
              }
            })
          ),
            newGridObjArr.push(Object.assign({}, newObj));
        });

        axios
          .all(promiseArr)
          .then(
            axios.spread((...res) => {
              let haveErrorMsg = res.forEach(response => {
                var r = response.data;
                if (r.code !== 200 && config.logApplicationError) {
                  console.error(r.message);
                  return r.message;
                }
              });

              // console.log(haveErrorMsg)
              if (haveErrorMsg) {
                NProgress.done();
                dispatch("actionSetBlock", false, {
                  root: true
                });
                dispatch("message/actionSetMessageStrOnly", haveErrorMsg, {
                  root: true
                });

                reject(haveErrorMsg);
              }

              newGridObjArr.forEach((newObj, index) => {
                let respData = Object.assign({}, res[index].data.data);
                // console.log(newObj.gridId + " index " + index);
                Object.entries(respData).forEach(([key, value]) => {
                  if (value !== undefined && value !== null) {
                    if (key == "tableData") {
                      newObj["data"] = value;
                    } else {
                      newObj[key] = value;
                    }
                  }
                });
                res[index].gridId = newObj.gridId;
                commit("setGrid", Object.assign({}, newObj));
              });

              commit("setViewMode", true);

              NProgress.done();
              dispatch("actionSetBlock", false, {
                root: true
              });

              resolve(res);
            })
          )
          .catch(error => {
            NProgress.done();
            dispatch("actionSetBlock", false, {
              root: true
            });
            dispatch("message/actionSetMessageStrOnly", error.message, {
              root: true
            });

            console.error(error);
            reject(error);
            // commit('setViewMode', true);
          });
      });
    }
  },
  // mutations
  mutations: {
    setViewMode(state, viewMode) {
      state.viewMode = viewMode;
    },

    setSelectRowsIndex(state, { gridId, selectRows }) {
      Vue.set(state.grid[gridId], "selectRowsIndex", selectRows);
    },
    setSelectRows(state, { gridId, selectRows }) {
      Vue.set(state.grid[gridId], "selectRows", selectRows);
    },
    setMode(state, { gridId, mode }) {
      Vue.set(state.grid[gridId], "mode", mode);
    },
    setTotalAmount(state, { gridId, totalAmount }) {
      //manumatch page must have this key and value
      if (state.grid[gridId].sum_amount_column) {
        Vue.set(state.grid[gridId], "totalAmount", totalAmount);
      }
    },
    setLoading(state, { gridId, loading }) {
      Vue.set(state.grid[gridId], "loading", loading);
    },
    setSelectRequestFilter(state, { gridId, requestFilter }) {
      Vue.set(state.grid[gridId], "requestFilter", requestFilter);
    },
    resetAllGrid(state) {
      Vue.set(state, "grid", {});
    },

    resetGrid(state, id) {
      Vue.set(state.grid, id, {});
    },

    reloadData(state, id) {
      if (state.grid[id]) {
        state.grid[id].data = [];
      }
    },
    setToggleGridResize(state, toggleGridResize) {
      state.toggleGridResize = toggleGridResize;
    },
    setColumnName(state, { gridId, colObj }) {
      Object.entries(colObj).forEach(([key, value]) => {
        state.grid[gridId][key] = value;
      });
    },
    setFilterItem(state, { gridId, filterItem }) {

      Vue.set(state.grid[gridId], "filterItem", filterItem);
    },
    //setGrid({gridid,griddata})
    setGrid(state, obj) {
      // console.time("set grid run time ");
      let tempObj = {};
      let newObj = {};
      //if the grid is exist
      if (state.grid[obj.gridId]) {
        Object.assign(tempObj, state.grid[obj.gridId]);
      }

      newObj = Object.assign(tempObj, obj);
      let page = newObj.page;

     

      if (newObj.columns) {
        let cols = [];
        let filters = [];
        newObj.columns.forEach(col => {
          if (col.formatter) {
            if (typeof col.formatter == "string") {
              col.formatterString = col.formatter;
            }

            if (col.link) {
              if (col.valField) {
                col.formatter = mapFormatters(col.formatter)(col.link, col.valField);
              } else {
                col.formatter = mapFormatters(col.formatter)(col.link);
              }

            } else if(col.selectList){
              col.formatter = mapFormatters(col.formatter)(col.selectList);
            }else {
              col.formatter = mapFormatters(col.formatter);
            }
          }

          if (col.editor && typeof col.editor == "string") {
            //special case
            if (col.editSelectList) {
              col.editor = mapEditors(col.editor)(col.editSelectList.slice(), col.valField);
            }else {             
              col.editor = mapEditors(col.editor);
            }
          }


          if (!col.isHidden) {
            cols.push({
              id: col.id,
              name: col.name,
              field: col.field,
              width: col.width,
              sortable: col.sortable,
              formatter: col.formatter,
              editor: col.editor,
              isHidden: col.isHidden,
              isFilterColumn: col.isFilterColumn,
              formatterString: col.formatterString,
              dataType:col.dataType
            });
          }

          // console.log(col.formatterString);

          let defaultFilterVal = col.defaultFilterVal || null;


          if (col.isFilterColumn) {
            if (
              col.dataType == filterType.DateRange ||
              col.dataType == filterType.AmountRange
            ) {
              let field = col.field;
              let date = {
                fieldType: col.dataType,
                model: col.field,
                id: col.id,
                placeholder: col.name,
                isRequired: col.isRequired,
                from: {
                  model: col.field + "_from",
                  placeholder: col.name + " From : ",
                  id: (col.id + "_from"),
                  fieldType: col.dataType,
                  list: col.selectList,
                  value: defaultFilterVal,
                  selectedIndex: null
                },
                to: {
                  model: col.field + "_to",
                  placeholder: col.name + " To : ",
                  id: (col.id + "_to"),
                  fieldType: col.dataType,
                  list: col.selectList,
                  value: defaultFilterVal,
                  selectedIndex: null
                }
              };
              filters.push(date);
            } else {
              if (newObj.filterItem) {
                Object.entries(newObj.filterItem).forEach(([key, value]) => {
                  if (key == col.field) {
                    defaultFilterVal = value;
                  }
                });
              }
              filters.push({
                id: col.id,
                model: col.field,
                placeholder: col.name,
                fieldType: col.dataType ? col.dataType : filterType.Tags, //default tags
                list: col.selectList,
                value: defaultFilterVal,
                selectedIndex: null,
                isRequired: col.isRequired
              });
            }
          }
        });

        newObj.columns = cols.slice();
        newObj.filters = filters.slice();
      }

      //ensure the neccessary key value
      newObj = keyMapping(newObj);

      //array must use Vue.set(object,key,val) for vue detection
      Vue.set(state.grid, newObj.gridId, newObj);

      // console.timeEnd("set grid run time ")
    }
  }
};

export default grid;

function keyMapping({
  gridId,
  data,
  requestId,
  columns,
  filters,
  loading,
  startIndex,
  pageNum,
  pageSize,
  totalRows,
  filterItem,
  totalAmount,
  requestFilter,
  selectRowsIndex,
  selectRows,
  isMainGrid,
  mode,
  baseUrl

}) {
  //init
  selectRowsIndex = selectRowsIndex || [];
  selectRows = selectRows || [];
  data = data || [];
  requestFilter = requestFilter || [];
  filterItem = filterItem || {}
  pageNum = pageNum || 0;
  totalRows = totalRows || 0;
  pageSize = pageSize || 100;
  baseUrl = baseUrl || "/";
  return Object.assign(
    {},
    {
      gridId,
      mode,
      data,
      columns,
      filters,
      loading,
      startIndex,
      pageNum,
      pageSize,
      totalRows,
      filterItem,
      totalAmount,
      requestId,
      requestFilter,
      selectRows,
      selectRowsIndex,
      isMainGrid,
      baseUrl
    }
  );
}



function mapFormatters(s) {
  if (typeof s == "function" || typeof s == "object") {
    return s;
  }
  let key = s.replace("Formatters.", "");
  return Formatters[key];
}

function mapEditors(s) {
  if (typeof s == "function" || typeof s == "object") {
    return s;
  }
  let key = s.replace("Editors.", "");
  return Editors[key];
}

